import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Home.css';

const roleLabels = {
  admin: 'Administrateur',
  superviseur: 'Superviseur',
};

const DashboardCard = ({ tag, title, description, to }) => (
  <Link to={to} className="dashboard-card">
    <span className="card-tag">{tag}</span>
    <h3>{title}</h3>
    <p>{description}</p>
    <span className="card-link">Accéder →</span>
  </Link>
);

const Home = () => {
  const { user, isAdmin } = useAuth();

  return (
    <div className="home-container">
      <div className="welcome-section">
        <div>
          <p className="welcome-eyebrow">Tableau de bord</p>
          <h1>Bienvenue, {user.username} !</h1>
        </div>
        <div className="welcome-badges">
          <span className="badge">{roleLabels[user.role] || 'Utilisateur'}</span>
          {user.module && <span className="badge badge-accent">Module {user.module}</span>}
        </div>
      </div>

      <div className="dashboard">
        {isAdmin() ? (
          <div className="admin-dashboard">
            <h2>Administration</h2>
            <div className="dashboard-cards">
              <DashboardCard
                tag="Admin"
                title="Gestion des utilisateurs"
                description="Créer, modifier et gérer les utilisateurs des modules ARA et ESSIE-EHOUN"
                to="/admin/users"
              />
              <DashboardCard
                tag="Admin"
                title="Envoi de SMS"
                description="Envoyer des SMS aux utilisateurs individuellement ou en groupe"
                to="/admin/sms"
              />
              <DashboardCard
                tag="ARA"
                title="Module ARA"
                description="Gestion des membres, cotisations, prestations et dépenses ARA"
                to="/ara"
              />
              <DashboardCard
                tag="ESSIE-EHOUN"
                title="Module ESSIE-EHOUN"
                description="Gestion des adhérents, cotisations et décès ESSIE-EHOUN"
                to="/essie-ehoun"
              />
            </div>
          </div>
        ) : (
          <div className="user-dashboard">
            <h2>Module {user.module}</h2>
            <div className="dashboard-cards">
              <DashboardCard
                tag="Compte"
                title="Mon profil"
                description="Consulter et modifier vos informations personnelles"
                to="/profile"
              />
              <DashboardCard
                tag={user.module}
                title="Mon module"
                description="Accéder aux fonctionnalités de votre module"
                to={user.module === 'ARA' ? '/ara' : '/essie-ehoun'}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
